import { render, staticRenderFns } from "./start-splash.vue?vue&type=template&id=119a0502&scoped=true&"
import script from "./start-splash.vue?vue&type=script&lang=ts&"
export * from "./start-splash.vue?vue&type=script&lang=ts&"
import style0 from "./start-splash.vue?vue&type=style&index=0&id=119a0502&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "119a0502",
  null
  
)

export default component.exports